import request from "../utils/request";

export const login = (data) => {
  return request({
    url: "/agent/login",
    method: "post",
    data,
  });
}

// 获取网点信息
export const getAgentInfo = query =>{
  return request({
    url: "/agent/getAgentInfo",
    method: "get",
    params: query,
    headers: {
      'Authorization': '1f55d1c564d442f38e4b8623c62fa3f3'
    },
  });
}
